const pagingDefaults = {
    amount: 25,
    start_cursor: '',
    end_cursor: '',
    has_previous: false,
    has_next: false,
};
const ExtendedPagingDefaults = Object.assign(Object.assign({}, pagingDefaults), { handleClickNext: () => { }, handleClickPrevious: () => { } });

export { ExtendedPagingDefaults as E, pagingDefaults as p };
